import { Stack, useLocalSearchParams, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";
import { LocationHeaderTemplate } from "app/features/locations/templates/LocationHeaderTemplate";
import { LocationProvider } from "app/features/locations/provider/LocationProvider";
import { Redirect } from "expo-router";

export default function LocationsLayout() {
  const locationId = Number(useLocalSearchParams().id);
  const pathname = usePathname();

  const tabs = [
    {
      label: "Residents",
      path: `/locations/${locationId}/residents`,
    },
    {
      label: "Users",
      path: `/locations/${locationId}/users`,
    },
  ];

  if (!locationId || isNaN(locationId)) {
    return <Redirect href="/locations" />;
  }
  return (
    <LocationProvider locationId={locationId}>
      <PageLayout
        header={<LocationHeaderTemplate />}
        tabs={tabs}
        currentPath={pathname}
        titleClassName="text-primary-800"
        className="p-dashboard"
      >
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "white" },
          }}
        />
      </PageLayout>
    </LocationProvider>
  );
}
